export default "__VITE_ASSET__612ed06d__"